<template>
  <div>
    <slot v-bind:company="company"> </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: {
        name: '(주)펀다에이아이',
        lendingRegisterNumber: '온라인투자연계금융업<br />2022-금융위원회-18',
        phoneNumber: '02-6925-1788',
        businessNumber: '724-87-00107',
        address: '서울시 금천구 가산디지털1로 70, 5층 514호(가산동, 호서대벤처타워)',
      },
    }
  },
}
</script>
